import React from "react";
//Material
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
/**
 * Primary UI component for user interaction
 */
const useStyles = makeStyles((theme) => ({
  Container: {
    paddingTop: theme.spacing(1),
    height: "85vh",
    overflow: "hidden",
  },
}));
export const BaseContainer = ({ children, ...props }) => {
  const classes = useStyles();
  return (
    <Container {...props} className={classes.Container} name="basecontainer" >
      <Box minHeight={'90%'}>{children}</Box>
    </Container>
  );
};

// Button.propTypes = {
//   /**
//    * Is this the principal call to action on the page?
//    */
//   primary: PropTypes.bool,
//   /**
//    * What background color to use
//    */
//   backgroundColor: PropTypes.string,
//   /**
//    * How large should the button be?
//    */
//   size: PropTypes.oneOf(['small', 'medium', 'large']),
//   /**
//    * Button contents
//    */
//   label: PropTypes.string.isRequired,
//   /**
//    * Optional click handler
//    */
//   onClick: PropTypes.func,
// };

// Button.defaultProps = {
//   backgroundColor: null,
//   primary: false,
//   size: 'medium',
//   onClick: undefined,
// };
export default BaseContainer;
